import { IAdfoxPuidsMap } from './adfox';
import { IBrokerData } from './broker';
import { INewbuilding, IBuilderStats, INewbuildingPromoSnippet } from './newbuilding';
import { ICompany } from './company';
import { IPromoPopup } from './promoPopup';

export type TGeoType = 'underground' | 'location';

export interface ISeo {
  description: string;
  uri: string;
  keywords: string;
  h1: string;
  title: string;
  subtitle: string;
  subtitles: string[];
  canonical?: string;
  geoType: TGeoType;
  text: string;
  seoLinks?: ISeoLink[];
  nonGeoQuery: string;
  query: string;
  ogTitle: string;
  markedList?: string[];
  markedListV2?: IMarkedList;
  keyPhrases?: string[];
  feature: string;
  locations?: Array<{
    id: number;
    type: string;
  }>;
  geoId?: number;
  geoTypeId?: number;
  aggregateRating?: number | null;
  reviewsCount?: number | null;
}

export interface IQuickLink {
  offersCount: number;
  title: string;
  url: string;
}

export interface ISeoLink {
  title: string;
  url: string;
}

export interface IQuickLinks {
  level: number;
  links: IQuickLink[];
}

export interface IBreadcrumb {
  title: string;
  url: string;
}

export interface IAnalytics {
  mlModelVersion: string | null;
  mlSearchGuid: string | null;
}

export interface ISalesDescription {
  salesType: ESalesType;
  text: string;
}

export interface ISalesLink {
  salesType: ESalesType;
  text: string;
  title: string;
  url: string;
}

export enum ESalesType {
  /** Чёрная пятница **/
  BlackFriday = 'blackFriday',
  /** Подбор новостроек */
  ConsultantPage = 'consultantPage',
  /** Главная каталога акций **/
  PromoIndexPage = 'promoIndexPage',
  /** Лидеры продаж **/
  SalesLeader = 'salesLeader',
  /** Старт продаж **/
  SalesStart = 'salesStart',
  /** Скоро в продаже **/
  UpcomingSale = 'upcomingSale',
  /** Льготная ипотека **/
  'DiscountMortgage' = 'discountMortgage',
}

export interface IMarkedList {
  items: IMarkedListItem[];
  schema?: string;
}

export interface IMarkedListItem {
  content: string;
  title: string;
}

export interface ISeoSchemas {
  mortgageDiscount: string;
  onlineShow: string;
  organizationInfo: string;
  wideSelection: string;
  product: string;
  breadcrumbs: string;
}

// TO Do
// будет в отдельной задаче добавленяия моделти
// tslint:disable:no-any
export interface IOffersDataState {
  breadcrumbs: IBreadcrumb[];
  newbuildings: INewbuilding[];
  newbuildingPromoSnippet?: INewbuildingPromoSnippet | null;
  similarNewbuildings: any[];
  seo: ISeo | null;
  seoSchemas?: ISeoSchemas | null;
  builder: ICompany | null;
  builderStats: IBuilderStats | null;
  fullUrl: string;
  total: number | null;
  newbuildingBuilderStats?: any[];
  quickLinks?: IQuickLinks | null;
  queryString: string;
  mapFullUrl?: string | null;
  salesDescription?: ISalesDescription | null;
  salesLeaderFullUrl: string;
  salesLinks?: ISalesLink[] | null;
  analytics: IAnalytics;
  newbuildingIdsForBuildersPromoSlider: number[];
  puids?: IAdfoxPuidsMap | null;
  newbuildingBroker?: IBrokerData;
  discountMortgagePopup?: IPromoPopup | null;
}
// tslint:disable:no-any
